import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.product.detailList;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'PRODUCT_DETAILLIST',
	url: '/product/detaillist.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
